import { useLanguage } from '../contexts/LanguageContext';

interface UseTranslationReturn {
  t: (key: string, replacements?: { [key: string]: string | number }) => any;
  isLoaded: boolean;
  currentLanguage: string;
}

export const useTranslation = (): UseTranslationReturn => {
  const { t, isLoaded, currentLanguage } = useLanguage();
  
  return { t, isLoaded, currentLanguage };
};